import { StringField } from "@overmap-ai/forms"
import type { ReactNode } from "react"

import {
	NullableStringEqualsFilterModifier,
	NullableStringNotEqualsFilterModifier,
	StringExcludesFilterModifier,
	StringIncludesFilterModifier,
} from "../../modifiers"
import { BaseFilterDef, createFilterModifierConfig, type FilterDefRenderProps } from "../BaseFilterDef"
import { StringFieldFilterCell } from "./StringFieldFilterCell"

type StringFieldValue = string | null
type StringFilterValue = string | null

export class StringFieldFilterDef extends BaseFilterDef<StringFieldValue, StringFilterValue> {
	readonly id: string
	readonly defaultFilterValue: StringFilterValue | undefined = undefined
	readonly defaultFilterModifier: keyof typeof this.modifiers = "equals"

	readonly field: StringField

	constructor(field: StringField) {
		super()
		this.field = field
		this.id = field.id
	}

	readonly modifiers = {
		equals: createFilterModifierConfig({
			modifier: NullableStringEqualsFilterModifier,
			isValueValid: (_value: StringFieldValue): _value is string => true,
			isFilterValueValid: (_filterValue: StringFilterValue): _filterValue is string | null => true,
		}),
		notEquals: createFilterModifierConfig({
			modifier: NullableStringNotEqualsFilterModifier,
			isValueValid: (value: StringFieldValue): value is string => value !== null,
			isFilterValueValid: (_filterValue: StringFilterValue): _filterValue is string | null => true,
		}),
		includes: createFilterModifierConfig({
			modifier: StringIncludesFilterModifier,
			isValueValid: (value: StringFieldValue): value is string => value !== null,
			isFilterValueValid: (filterValue: StringFilterValue): filterValue is string => filterValue !== null,
		}),
		excludes: createFilterModifierConfig({
			modifier: StringExcludesFilterModifier,
			isValueValid: (value: StringFieldValue): value is string => value !== null,
			isFilterValueValid: (filterValue: StringFilterValue): filterValue is string => filterValue !== null,
		}),
	}

	render(props: FilterDefRenderProps<StringFieldFilterDef>): ReactNode {
		return <StringFieldFilterCell key={props.filter.id} field={this.field} {...props} />
	}
}
